import React from 'react'

import Nav from '../../Components/Patient/Nav/Nav'
import ContactUs from '../../Components/Patient/ContactUs/ContactUs'

function ContactUsForm() {
  return (
    <div>
      <Nav />
      <ContactUs></ContactUs>
    </div>
  )
}

export default ContactUsForm